import { FctAddress, FctAddressList, FctTimestamp, FctValue, maxValue } from '../../../../Fct/generics';
import { toBN } from 'web3-utils';
export var amountOutMinRisk = {
    description: 'Transaction may be frontrun',
    isDanger: function (param) {
        if (!param)
            return true;
        if (typeof param === 'string') {
            if (parseFloat(param) <= 0)
                return true;
            return false;
        }
        return true;
    },
};
export var amountInMaxRisk = {
    description: 'Transaction may be frontrun',
    isDanger: function (param) {
        if (!param)
            return true;
        if (typeof param === 'string') {
            if (toBN(param).gte(toBN(maxValue)))
                return true;
            return false;
        }
        return true;
    },
};
export var swapEthForExactTokensParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        methodParams: {
            amountOut: new FctValue({ destination: 'wei_amount' }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
export var swapExactEthForTokensParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        value: new FctValue({ destination: 'wei_amount' }),
        methodParams: {
            amountOutMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
export var swapExactTokensForEthParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        methodParams: {
            amountIn: new FctValue({ destination: 'wei_amount' }),
            amountOutMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
export var swapExactTokensForTokensParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        methodParams: {
            amountIn: new FctValue({ destination: 'wei_amount' }),
            amountOutMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
export var swapTokensForExactTokensParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        methodParams: {
            amountIn: new FctValue({ destination: 'wei_amount' }),
            amountInMax: new FctValue({ destination: 'wei_amount' }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
export var swapTokensForExactETHParams = {
    input: {
        to: new FctAddress({ destination: 'uniswap_router' }),
        methodParams: {
            amountOut: new FctValue({ destination: 'wei_amount' }),
            amountInMax: new FctValue({ destination: 'wei_amount' }),
            path: new FctAddressList({ destination: 'ERC20_List' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
        amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
    },
};
